(function() {
  function filterGalleryByColour(colourValue) {
    var mediaItems = document.querySelectorAll('li.product__media-item');
    if (!mediaItems.length) return;
    var colour = colourValue.trim().toLowerCase();
    var anyVisible = false;
    mediaItems.forEach(function(item) {
      var img = item.querySelector('img');
      var alt = (img && (img.alt || img.getAttribute('alt')) || '').toLowerCase();
      if (alt.includes(colour)) {
        item.style.removeProperty('display');
        anyVisible = true;
      } else {
        item.style.display = 'none';
      }
    });
    if (!anyVisible) mediaItems.forEach(function(item) { item.style.removeProperty('display'); });
  }

  function getSelectedColour() {
    var input = document.querySelector('input[type="radio"][name^="Color"]:checked, input[type="radio"][name*="Color"]:checked');
    return input ? input.value : null;
  }

  function init() {
    // Listen for colour radio changes
    document.addEventListener('change', function(e) {
      var t = e.target;
      if (t && t.type === 'radio' && t.name && t.name.indexOf('Color') !== -1) {
        filterGalleryByColour(t.value);
      }
    });
    // Apply on load
    setTimeout(function() {
      var c = getSelectedColour();
      if (c) filterGalleryByColour(c);
    }, 800);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();